<template>
  <div
    :id="brainsDescriptionContainerId"
    :class="{ 'brains-description-container--editable': contenteditable, 'brains-description-container--no-editable': !editable }"
    class="brains-description-container"
  >
    <div v-if="editable" class="description--text" :contenteditable="contenteditable" v-html="text" />
    <div v-else class="description--text" :contenteditable="false" v-html="text" />
    <div v-if="editable" class="description--btn"><em class="el-icon-edit-outline" @click="activeModal = false" /></div>
  </div>
</template>

<script>
export default {
  name: 'BrainsDescription',
  props: {
    value: {
      type: String,
      default: '',
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      text: this.value,
      contenteditable: false,
      randomNum: 0
    }
  },
  computed: {
    brainsDescriptionContainerId() {
      return 'brains-description-container-' + this.randomNum
    }
  },
  watch: {
    value() {
      this.text = this.value
    },
    contenteditable(newOne, oldOne) {
      if (!newOne) {
        this.handleText()
        this.$emit('endEdit', true)
      }
    },
    editable(newOne, oldOne) {
      if (newOne) {
        this.initComp()
      }
    }
  },
  mounted() {
    this.generateRandomNum()
    if (this.editable) {
      setTimeout(() => {
        this.initComp()
      }, 200)
    }
  },
  methods: {
    initComp() {
      var item = document.getElementById(this.brainsDescriptionContainerId)
      if (item !== null && item !== undefined) {
        item.addEventListener('click', () => {
          this.contenteditable = true
        })
      }

      window.addEventListener('click', (e) => {
        if (!item.contains(e.target)) {
          this.contenteditable = false
        }
      })
    },
    handleText(e) {
      this.$emit('input', document.querySelector('#' + this.brainsDescriptionContainerId + ' .description--text').innerHTML)
    },
    generateRandomNum() {
      this.randomNum = Math.floor(Math.random() * (9999 - 0)) + 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.brains-description-container {
  width: 100%;
  // height: 62px;
  border: 2px solid rgb(194, 194, 194);
  padding: 15px 20px;
  padding-right: 50px;
  position: relative;

  &--editable {
    border: 2px solid $primary-brains;
    .description--btn {
      color: $primary-brains;
    }
  }

  &--no-editable {
    border: 2px solid rgb(194, 194, 194);
    background-color: rgb(240, 240, 240);
    padding-right: 20px;
  }
}

.description {
  &--text {
    width: 100%;
    height: 100%;
    font-size: 12px;
    font-family: "Montserrat-Light",sans-serif;
    line-height: 20px;
    max-height: 220px;
    overflow: scroll;
    text-align: justify;
  }

  &--btn {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 30px;
    color: rgb(194, 194, 194);
    cursor: pointer;

    &:hover {
      color: $primary-brains;
    }
  }
}
</style>
